module.exports = __webpack_public_path__ + "img/oxygen_flow_rate_table.883a82b3.png";